// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card[data-v-72080dc1]{display:flex;flex-direction:column;padding:24px;border-radius:8px;background-color:#201136;height:100%}.card__link[data-v-72080dc1]{display:flex;align-items:center;gap:8px;margin-top:auto;color:#9C87FB;font-weight:700;text-decoration:none}.card__link[data-v-72080dc1]:hover{color:#9C87FB}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
